<template>
    <div>
        <div class="public-profile-wrapper">
            <div class="flex flex-column col-12 px-4 lg:flex-row gap-4 mt-4 justify-content-center">
                <div class="w-full">
                    <div class="mb-7">
                        <h3 class="Paragraph-Medium font-semibold mb-3">Personal Information</h3>
                        <ul class="list-none p-0 m-0">
                            <li class="flex align-items-start gap-2 mb-4">
                                <i class="pi pi-calendar text-500 mt-1"></i>
                                <div class="flex flex-column">
                                    <span class="Paragraph-Medium mb-1">Age:</span>
                                    <span>{{ profileDetails.age || 'N/A' }}</span>
                                </div>
                            </li>
                            <li class="flex align-items-start gap-2 mb-4">
                                <i class="pi pi-globe text-500 mt-1"></i>
                                <div class="flex flex-column">
                                    <span class="Paragraph-Medium mb-1">Language:</span>
                                    <span>{{ cleanupLables(profileDetails.language) || 'N/A' }}</span>
                                </div>
                            </li>
                            <li class="flex align-items-start gap-2 mb-4">
                                <i class="pi pi-map-marker text-500 mt-1"></i>
                                <div class="flex flex-column">
                                    <span class="Paragraph-Medium mb-1">Location:</span>
                                    <span>{{ profileDetails.city || 'N/A' }}</span>
                                </div>
                            </li>
                            <li class="flex align-items-start gap-2 mb-4">
                                <i class="pi pi-flag text-500 mt-1"></i>
                                <div class="flex flex-column">
                                    <span class="Paragraph-Medium mb-1">Nationality:</span>
                                    <span>{{ profileDetails.nationality || 'Sri Lanka' }}</span>
                                </div>
                            </li>
                            <li class="flex align-items-start gap-2 mb-4">
                                <i class="pi pi-building text-500 mt-1"></i>
                                <div class="flex flex-column">
                                    <span class="Paragraph-Medium mb-1">School:</span>
                                    <span>{{ profileDetails.currentInstitution || 'N/A' }}</span>
                                </div>
                            </li>
                            <li class="flex align-items-start gap-2 mb-4">
                                <i class="pi pi-star text-500 mt-1"></i>
                                <div class="flex flex-column">
                                    <span class="Paragraph-Medium mb-1">Grade:</span>
                                    <span>{{ cleanupLables(profileDetails.currentEducationLevel) || 'N/A' }}</span>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="mb-7">
                        <h3 class="font-semibold Paragraph-Medium mb-3">Learning Preferences</h3>
                        <ul class="list-none p-0 m-0 mb-3">
                            <li class="mb-2 Paragraph-Medium">
                                Class Type :
                                <span v-if="profileDetails.preferredLearningMode?.length" class="Label">
                                    {{ profileDetails.preferredLearningMode.map(mode => cleanupLables(mode)).join(', ') }}
                                </span>
                                <span v-else>Online</span>
                            </li>
                            <li class="Paragraph-Medium">
                                Class Time :
                                <span v-if="profileDetails.preferredClassTime?.length" class="Label">
                                    {{ profileDetails.preferredClassTime.map(time => cleanupLables(time)).join(', ') }}
                                </span>
                                <span v-else>Group</span>
                            </li>
                        </ul>
                    </div>
                    <div>
                        <h3 class="font-semibold Paragraph-Medium mb-3">Preferred Subjects</h3>
                        <ul class="list-none p-0 m-0 flex flex-wrap gap-2">
                            <li v-for="(subject, index) in profileDetails.interestedSubjects" :key="index"
                                class="border-1 border-300 border-round-3xl bg-transparent py-2 px-3 text-sm">
                                {{ cleanupLables(subject) }}
                            </li>
                        </ul>
                    </div>
                </div>
                <Divider layout="vertical" />
                <div class="w-full  p-4">
                    <div class="mb-4">
                        <h3 class="font-semibold Paragraph-Medium mb-3">About Me</h3>
                        <p class="line-height-3 Label m-0">
                            {{ profileDetails.bio || "No description provided." }}
                        </p>
                    </div>


                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import Divider from "primevue/divider";
import { defineProps } from "vue";
import { cleanupLables } from "@/utils/cleanups";
defineProps({
    profileDetails: null
})
</script>

<style scoped></style>